import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.ash,
  errorColor: colors.warningRed,
  borderColor: colors.ash,
  linkColor: colors.tomatoRed,
  documentFormBgColor: colors.white,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default form;